// removed by extract-text-webpack-plugin
module.exports = {"fields":"c-IngridFieldsForm__fields","message":"c-IngridFieldsForm__message","openInfo":"c-IngridFieldsForm__openInfo","disabledButtonWrapper":"c-IngridFieldsForm__disabledButtonWrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/IngridFieldsForm/IngridFieldsForm.scss
// module id = 544
// module chunks = 0